/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxNormalUploadSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_NORMAL_UPLOAD_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class MaxNormalUploadSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxNormalUploadSizeSettingParser.decode(input).map(res => new MaxNormalUploadSizeSetting(res));
    }
    static unsafeDecode(input) {
        return MaxNormalUploadSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxNormalUploadSizeSettingParser.encode(data);
    }
    static schema() {
        return MaxNormalUploadSizeSettingParser.schema();
    }
}
